import { css } from '@emotion/react'
import { Tooltip, Typography } from '@mui/material'
import { HTMLAttributes, ReactNode } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { navItemStyle } from 'src/features/globalNavigation/components/navItem/navItemStyle'
import { globalNavigationTheme } from 'src/features/globalNavigation/theme'

type NavItemInternalLinkProps = {
  icon: ReactNode
  /**
   * 内部リンク
   * e.g. `/dashboards
   */
  internalPath: string
  isBeta?: boolean
  /**
   * 折り畳まれているかどうか
   */
  isCollapsed: boolean
  title: string
} & HTMLAttributes<HTMLElement>

/**
 * グローバルナビゲーションの個々のアイテム (内部リンク)
 */
export const NavItemInternalLink: React.FC<NavItemInternalLinkProps> = (
  props: NavItemInternalLinkProps,
) => {
  const {
    icon,
    internalPath,
    isBeta = false,
    isCollapsed,
    title,
    ...restProps
  } = props

  const { pathname } = useLocation()
  let isActive = false
  if (internalPath) {
    isActive = pathname.startsWith(internalPath)
  }

  // 開閉状態に応じて表示内容を切り替える
  let content: ReactNode
  if (isCollapsed) {
    content = <>{icon}</>
  } else {
    content = (
      <>
        {icon}
        <Typography variant="subtitle2">
          {title}
          {isBeta && ' (β版)'}
        </Typography>
      </>
    )
  }

  return (
    <Tooltip title={isCollapsed ? title : ''} placement="right" arrow>
      <Link
        {...restProps}
        css={[
          navItemStyle.container,
          isCollapsed && navItemStyle.containerCollapsed,
          isActive && styles.containerActive,
        ]}
        to={internalPath}
        aria-label={title}
      >
        {content}
      </Link>
    </Tooltip>
  )
}

const styles = {
  containerActive: css`
    background: ${globalNavigationTheme.backgroundHover};
  `,
}
